<template>
  <Layout>
    <VContainer grid-list-xl>
      <VLayout justify-center>
        <VFlex sm10 xl8>
          <VLayout row wrap justify-center>
            <VFlex xs12 md3>
              <VCard>
                <StaticInfoList></StaticInfoList>
              </VCard>
            </VFlex>
            <VFlex xs12 md9>
              <NuxtChild></NuxtChild>
            </VFlex>
          </VLayout>
        </VFlex>
      </VLayout>
    </VContainer>
  </Layout>
</template>
<script>
import StaticInfoList from '../components/StaticInfoList'
import Layout from '../components/layout/Layout'
export default {
  components: { Layout, StaticInfoList }
}
</script>
